// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import config from '../config';
import { nativeTokenCache } from '../utils/tokenStorage';

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl:  config.API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      // On native, also send the stored token as Bearer so the API can
      // authenticate even when the Capacitor origin doesn't match the cookie
      // domain. (Server must accept Bearer tokens for this to take effect.)
      if (nativeTokenCache) {
        headers.set('Authorization', `Bearer ${nativeTokenCache}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
})
